export const bonusesEnabled: boolean = false;
